<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import HomeInsuranceData from '@/data/company-page-data/turk-nippon-sigorta/cross-pages/HomeInsurance'
export default {
  metaInfo: {
    title: 'Türk Nippon Sigorta Konut Sigortası Hesaplama, Teklif Alma',
    meta: [
      {
        name: 'description',
        content: 'Türk Nippon Sigorta Konut Sigortası fiyatı almak için teklif formunu doldurun. En uygun ev sigortası ücretlerini karşılaştırın, poliçenizi satın alın.'
      }
    ]
  },
  name: 'TurkNipponSigortaHomeInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: HomeInsuranceData.headerContent,
      crossPageContent: HomeInsuranceData.crossPageContent,
      faqTitle: HomeInsuranceData.faqTitle,
      faqTitleDesc: HomeInsuranceData.faqTitleDesc,
      questions: [],
      getPrice: HomeInsuranceData.getPrice
    }
  }
}
</script>
